import { useEffect, useState } from 'react';

import { programBoardAuthDetail } from '@/network/apis/apiUri';

export default function ProgramSendMessageView(props) {
  const { mode, selBoard, history, itemId } = props;

  const [detailData, setDetailData] = useState();

  useEffect(() => {
    programBoardAuthDetail({
      board_id: selBoard.boardId,
      board_item_id: itemId,
      hit: true,
    })
      .then((res) => {
        if (res.status === 200) {
          const _data = res.data;
          setDetailData({
            title: _data.title.find((el) => el.lan_code === mode).text,
            content: _data.content.find((el) => el.lan_code === mode).text.replace(/(?:\r\n|\r|\n)/g, '<br />'),
            regDate: _data.reg_date ? _data.reg_date.slice(0, -2) : '',
            hitCount: _data.hit_count,
          });
        }
      })
      .catch((e) => {
        if (e.response) {
          const result = e.response.data.resultCode.code;
          if (result === 401101) {
            if (mode === 'ko') alert('작성자만 확인가능합니다. 로그인 인증 후 확인해주세요.');
            if (mode === 'en') alert('Only the author can check. Please verify after logging in.');
          }
          if (result === 401002) {
            if (mode === 'ko') alert('만료된 토큰입니다. 로그인을 다시 진행해주세요.');
            if (mode === 'en') alert('This token is expired. Please log in again');
            localStorage.removeItem('userData');
          }
          if (e.reponse.status === 500) {
            if (mode === 'ko') alert('잠시후 다시 시도해 주세요.');
            if (mode === 'en') alert('Please try again in a few minutes.');
          }

          history.go(0);
        }
      });
  }, []);

  if (!detailData) return null;
  return (
    <div id="CommonProgramBoardView" className="commonProgramBoardView">
      <h2 className="commonProgramBoardView_title">{selBoard.title}</h2>
      <div className="commonProgramBoardView_content">
        <div className="commonProgramBoardView_content_title-wrap">
          <div className="title-wrap">
            <h4
              className="title"
              dangerouslySetInnerHTML={{
                __html: detailData.title,
              }}
            ></h4>
            <div className="info titleStyle_0">
              <span className="info_date time-fs-fixed">{detailData.regDate}</span>
            </div>
          </div>
          <button type="button" className="btnList" onClick={() => history.goBack()}>
            목록
          </button>
        </div>

        <div
          className="commonProgramBoardView_content_info"
          dangerouslySetInnerHTML={{
            __html: detailData.content,
          }}
        />
      </div>
      <div className="commonProgramBoardView_footer">
        <button type="button" className="btnList" onClick={() => history.goBack()}>
          목록
        </button>
      </div>
    </div>
  );
}
